const SearchField = (function () {
  const defaultSelector = '.c-search__input'
  const searchPageSelector = '.c-search__input.c-search--search-page'
  const mapPageSelector = '.c-search__input.c-search--map-page'
  const clearBtnSelector = '.c-search__clear-btn'
  const defaultInputElement = document.querySelector(defaultSelector)
  const searchPageInputElement = document.querySelector(searchPageSelector)
  const mapPageInputElement = document.querySelector(mapPageSelector)
  const clearBtnElement = document.querySelector(clearBtnSelector)

  const addInputEventListener = (inputElement) => {
    if (inputElement.value && inputElement.value.length > 0) {
      showClearButton()
    } else {
      hideClearButton()
    }
  }

  const showClearButton = () => {
    clearBtnElement.style.display = 'block'
  }

  const hideClearButton = () => {
    clearBtnElement.style.display = 'none'
  }

  const addFocusedClass = () => {
    if (!defaultInputElement.classList.contains('c-search__input--focused')) {
      defaultInputElement.classList.add('c-search__input--focused')
    }
  }

  const removeFocusedClass = () => {
    if (defaultInputElement.classList.contains('c-search__input--focused')) {
      defaultInputElement.classList.remove('c-search__input--focused')
    }
  }

  const initDefaultSearchField = () => {
    defaultInputElement.addEventListener('input', (e) => {
      addInputEventListener(e.target)
    })
    defaultInputElement.addEventListener('focus', (e) => {
      addInputEventListener(e.target)
    })
    clearBtnElement.addEventListener('click', (e) => {
      defaultInputElement.value = ''
    })
  }

  const initSearchAndMapPageSearchField = () => {
    if (searchPageInputElement || mapPageInputElement) {
      if (defaultInputElement.value && defaultInputElement.value.length > 0) {
        showClearButton()
        addFocusedClass()
      }

      defaultInputElement.addEventListener('focusout', (e) => {
        if (defaultInputElement.value === '') {
          hideClearButton()
          removeFocusedClass()
        }
      })

      clearBtnElement.addEventListener('click', (e) => {
        // Get current URL with query params
        let queryString = window.location.search
        const urlParams = new URLSearchParams(queryString)

        // Remove keyword query param
        urlParams.delete('keyword')

        const url = new URL(window.location.href)
        // Add updated query params
        url.search = urlParams.toString()
        // Reload page without keyword query param / empty search
        window.location.href = url.href
      })
    }
  }

  return {
    init: () => {
      if (defaultInputElement) {
        initDefaultSearchField()
        initSearchAndMapPageSearchField()
      }
    },
  }
})()

export default SearchField
